<template lang="pug">
	div.step-content.state-select(v-if="ready")
		h2.mb-5(v-if="fullQuestion") What is your state of residence?
		//sfc-select-wrapper(:errorMessage="''" :error="false" :flat="false")
			select(v-model="stateOfResidence")
				option(value="-" disabled hidden) Select your state
				option(v-for="state of states" :key="state.id" v-bind:value="state") {{state.name}}
		//div.complete-onboarding-btn(v-if="fullQuestion")
			button.btn.sfc-blue(@click="next()")
				| OK
				span.arrow-right
		//a.btn.sfc-blue(@click="next()" :loading="loading" ref="") {{buttonText}}
		a.btn.orange(@click="next()" :loading="loading" ref="") {{buttonText}}

</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	a.btn
		padding: 13px 20px
		margin: 0
		border-radius(25px)
		width: 200px
		font-size: 18px
		font-weight: 600
	&.orange
		background: #f47810 !important
		color: #fff !important
		border: none !important
		&:hover
			background: #da6d12 !important
	.complete-onboarding-btn
		.btn
			position: relative
			display: inline-block
			margin-left: 0px
			padding-right: 30px
			span.arrow-right
				border-left-color: #fff
			&:hover
				+ .press-enter
					color: sfc-blue-link
	.state-select
		>>> .select-container
			@media(max-width: 575px)
				margin: 0 auto

		>>> select
			@media(max-width: 767px)
				font-size: body-font-size-md !important

		@media(max-width: 575px)
			text-align: center
			>>> .dd
				label
					margin: auto
</style>

<script>
	import InputBtnWrapper from '@/common/components/inputs/btn-wrapper'
	import SfcTrackingService from "@/lib/sfc-tracking-service"

	export default {

		layout: 'default',

		props: {
			buttonText: {
				default: "SHOW ME"
			}
		},

		components: {
			InputBtnWrapper
		},

		data(){
			let currentState = "-"
			return {
				ready: true,
				stateOfResidence: currentState,
				states: this.$store.state.states,
				savingsUser: null,
				error: false,
				errorMessage: "Please choose your state",
				loading: false,
				fullQuestion: false,
				modalOpened: false
			}
		},

		mounted(){
			this.stateOfResidence = {
				id: this.$store.state.stateFromIp.sfc_id,
				name: this.$store.state.stateFromIp.name,
				string_id: this.$store.state.stateFromIp.id
			}
		},

		methods:{

			openModal(){
				this.$sfcModal.open("sfc-onboarding-modal-v3-2")
			},

			setState(state){

				if(!state) return

				this.$store.commit(
					'updateCollegeSavingsUserOnboarding',
					{
						part: "state",
						value: state
					}
				)

			},

			async nextStep(){
				let token = this.$cookies.get("sfc_primary")
				let collegeSavingsUser = undefined

				let nextStep = undefined
				try{
					if (
						this.$store.state.collegeSavingsUserOnboarding["next_step_v3"] &&
						this.$store.state.collegeSavingsUserOnboarding["next_step_v3"] != "null" &&
						this.$store.state.collegeSavingsUserOnboarding["next_step_v3"] != "undefined"
					){
						nextStep = this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]
					}
				}
				catch(err){
					nextStep = undefined

				}

				if (token){
					if (this.$store.state.collegeSavingsUserOnboarding  && nextStep){
						return `/savings-center/${nextStep}`
					}
				}
				else{
					return false
				}

				const query = `
					query{
						no_graphql_cache()
						college_savings_user_v3(sfc_token: "${token}"){
							id
							next_step_v3
							type_of_user
							children{
								id
								name
								age
							}
							state{
								id
								name
								slug
							}
							email
							primary_id
						}
					}
				`

				this.loading = true
				try {
					let result = await this.$httpService.graphql(query)
					collegeSavingsUser = result.data.college_savings_user_v3
				} catch (e) {
					collegeSavingsUser = undefined

				}
				this.loading = false

				if (!collegeSavingsUser || !collegeSavingsUser.next_step_v3) return false

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "next_step_v3", value: collegeSavingsUser.next_step_v3})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "type_of_user", value: collegeSavingsUser.type_of_user})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "children", value: collegeSavingsUser.children})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "state", value: collegeSavingsUser.state})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "email", value: collegeSavingsUser.email})

				return `/savings-center/${collegeSavingsUser.next_step_v3}`
			},

			async next(){
				this.$emit("click")

				let nextPageUrl = false

				this.$cookies.set('fired_once', true, {
					path: '/',
					domain: 'savingforcollege.com',
					maxAge: 24 * 60 * 60
				})
				this.setState(this.stateOfResidence)

				nextPageUrl = await this.nextStep()

				if(nextPageUrl){
					window.location.href = nextPageUrl
				}else{
					SfcTrackingService.trackAnalyticsAction("Savings Center Navigation", "click", "Homepage Sentence", 0)

					// Reset state in order to open the modal on state selection
					this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "state", value: null})

					this.$sfcModal.open("sfc-onboarding-modal-v3-2")
				}
			}
		},

	}
</script>
